import { RangeSliderProps } from "@mantine/core"
import {
  HTMLPropsRef,
  MRT_RowData,
  MRT_TableOptions,
  MRT_TableInstance,
} from "mantine-react-table"

import { formatNumber } from "@costory/shared/utils/format"

const getTableContainerProps = <T extends MRT_RowData>(
  table: MRT_TableInstance<T>,
) => {
  const isFullScreen = table.getState().isFullScreen
  return {
    style: {
      height: "auto",
      overflow: "auto",
      paddingBottom: isFullScreen ? "32px" : "0px",
    },
  }
}

const getTableFooterProps = () => ({
  style: {
    outline: "none",
  },
})

export const getDefaultTableOptions = <T extends MRT_RowData>(
  enableTopToolbar: boolean = false,
): Partial<MRT_TableOptions<T>> => ({
  enableTopToolbar,
  enableColumnFilters: true,
  enableColumnFilterModes: false,
  enableFacetedValues: true,
  paginationDisplayMode: "pages",
  mantinePaperProps: {
    shadow: "none",
    style: {
      border: "1px solid",
      borderColor: "var(--mantine-color-border-0)",
      borderRadius: 8,
    },
  },
  mantinePaginationProps: {
    showRowsPerPage: false,
  },
  mantineTableContainerProps: ({ table }) => getTableContainerProps<T>(table),
  mantineTableFooterProps: getTableFooterProps(),
})

export const CURRENCY_FILTER_VARIANT: {
  filterVariant: "range-slider"
  mantineFilterRangeSliderProps: HTMLPropsRef<HTMLInputElement> &
    Partial<RangeSliderProps>
} = {
  filterVariant: "range-slider",
  mantineFilterRangeSliderProps: { label: (value) => formatNumber({ value }) },
}

export const getCommonTableStyleProps = <
  T extends MRT_RowData = MRT_RowData,
>() => ({
  mantineTableBodyCellProps: {
    style: {
      paddingBlock: "12px",
    },
  },
  mantineTableContainerProps: ({ table }: { table: MRT_TableInstance<T> }) =>
    getTableContainerProps<T>(table),
  mantineTableFooterProps: getTableFooterProps(),
})
